<template>
	<div class="block-color pr overflow-hidden">
		<strong class="title f5 fw5 ">Theme colors</strong>
		<p>Click on a swatch to change a color variable’s value across the theme.</p>

		<ul class="list-color">
			<li>
				<div :class="[`color-preview pointer`, $css(styles.windowPreview)]"
					 data-color="window" @click="onColorClick"></div>
				<span :class="[`color-title`, $css(styles.colorTitle)]">window</span>
				<span class="color-code">{{colors.window}}</span>
			</li>
			<li>
				<div :class="[`color-preview pointer`, $css(styles.bgPreview)]"
					 data-color="sourceBg" @click="onColorClick"></div>
				<span :class="[`color-title`, $css(styles.colorTitle)]">sourceBg</span>
				<span class="color-code">{{colors.sourceBg}}</span>
			</li>
			<li>
				<div :class="[`color-preview pointer`, $css(styles.borderPreview)]"
					 data-color="windowBorder" @click="onColorClick"></div>
				<span :class="[`color-title`, $css(styles.colorTitle)]">windowBorder</span>
				<span class="color-code">{{colors.windowBorder}}</span>
			</li>
			<li>
				<div :class="[`color-preview pointer`, $css(styles.miPreview)]"
					 data-color="menuIcons" @click="onColorClick"></div>
				<span :class="[`color-title`, $css(styles.colorTitle)]">menuIcons</span>
				<span class="color-code">{{colors.menuIcons}}</span>
			</li>
		</ul>

		<ul class="list-color style">
			<li>
				<div :class="[`color-preview pointer`, $css(styles.tiPreview)]"
					data-color="tabIcon" @click="onColorClick"></div>
				<span :class="[`color-title`, $css(styles.colorTitle)]">tabIcon</span>
				<span class="color-code">{{colors.tabIcon}}</span>
			</li>
			<li>
				<div :class="[`color-preview pointer`, $css(styles.itiPreview)]"
					data-color="inactiveTabIcon" @click="onColorClick"></div>
				<span :class="[`color-title`, $css(styles.colorTitle)]">inactiveTabIcon</span>
				<span class="color-code">{{colors.inactiveTabIcon}}</span>
			</li>
			<li>
				<div :class="[`color-preview pointer`, $css(styles.linkPreview)]"
					data-color="link" @click="onColorClick"></div>
				<span :class="[`color-title`, $css(styles.colorTitle)]">link</span>
				<span class="color-code">{{colors.link}}</span>
			</li>
			<li>
				<div :class="[`color-preview pointer`, $css(styles.actionPreview)]"
					data-color="action" @click="onColorClick"></div>
				<span :class="[`color-title`, $css(styles.colorTitle)]">action</span>
				<span class="color-code">{{colors.action}}</span>
			</li>
		</ul>

		<ul class="list-color style">
			<li>
				<div :class="[`color-preview pointer`, $css(styles.inpPreview)]"
					data-color="inProgress" @click="onColorClick"></div>
				<span :class="[`color-title`, $css(styles.colorTitle)]">inProgress</span>
				<span class="color-code">{{colors.inProgress}}</span>
			</li>
			<li>
				<div :class="[`color-preview pointer`, $css(styles.completePreview)]"
					data-color="complete" @click="onColorClick"></div>
				<span :class="[`color-title`, $css(styles.colorTitle)]">complete</span>
				<span class="color-code">{{colors.complete}}</span>
			</li>
			<li>
				<div :class="[`color-preview pointer`, $css(styles.errorPreview)]"
					 data-color="error" @click="onColorClick"></div>
				<span :class="[`color-title`, $css(styles.colorTitle)]">error</span>
				<span class="color-code">{{colors.error}}</span>
			</li>
		</ul>

		<ul class="list-color style">
			<li>
				<div :class="[`color-preview pointer`, $css(styles.ltxtPreview)]"
					 data-color="textLight" @click="onColorClick"></div>
				<span :class="[`color-title`, $css(styles.colorTitle)]">light text color</span>
				<span class="color-code">{{colors.textLight}}</span>
			</li>
			<li>
				<div :class="[`color-preview pointer`, $css(styles.dtxtPreview)]"
					 data-color="textDark" @click="onColorClick"></div>
				<span :class="[`color-title`, $css(styles.colorTitle)]">dark text color</span>
				<span class="color-code">{{colors.textDark}}</span>
			</li>
		</ul>

		<ColorPicker :color="activeValue" v-if="activeColor"
					 :position="pickerPosition"
					 v-on:change="onColorPickerChange"
					 v-on:clickedAway="onPickerClickAway">
		</ColorPicker>
	</div>
</template>

<script>
	import {mapState, mapActions} from "vuex";

	import {getInMediaQuery as gimq, MQ_SIZES} from "@/utils/cssUtils";
	import {types} from "@/store/modules/widget";
	import ColorPicker from "../simple/ColorPicker";

	const PICKER_WIDTH = 225,
		PICKER_HEIGHT = 250;

	function styles() {
		return this.$style({
			colorTitle: gimq(MQ_SIZES.S, {fontSize: "10px"}),
			windowPreview: {background: this.colors.window},
			bgPreview: {background: this.colors.sourceBg},
			borderPreview: {background: this.colors.windowBorder},
			miPreview: {background: this.colors.menuIcons},
			tiPreview: {background: this.colors.tabIcon},
			itiPreview: {background: this.colors.inactiveTabIcon},
			linkPreview: {background: this.colors.link},
			actionPreview: {background: this.colors.action},
			inpPreview: {background: this.colors.inProgress},
			completePreview: {background: this.colors.complete},
			errorPreview: {background: this.colors.error},
			dtxtPreview: {background: this.colors.textDark},
			ltxtPreview: {background: this.colors.textLight},
		});
	}

	export default {
		name: "PaletteColors",

		components: {
			ColorPicker

		},
		data() {
			return {
				activeColor: null,
				activeValue: null,
				pickerPosition: null,
			};
		},

		computed: {
			...mapState({
				colors: (state) => state.widget.colors,
			}),
			styles
		},

		methods: {
			...mapActions("widget", [
				types.SET_COLOR,
			]),

			onColorClick(e) {
				setTimeout(()=>{ //allows clicking on another color while picker already open
					const button = e.target,
						colorName = button.dataset["color"],
						offsetParent = button.offsetParent,
						pos = {
							left: Math.min(offsetParent.clientWidth - PICKER_WIDTH, button.offsetLeft),
							top: Math.min(offsetParent.clientHeight - PICKER_HEIGHT, button.offsetTop)
						};

					this.activeColor = colorName;
					this.activeValue = this.colors[colorName];
					this.pickerPosition = pos;
				}, 10);
			},

			onColorPickerChange(value) {

				//todo: throttle !!!!!!!!!!

				this[types.SET_COLOR]({name: this.activeColor, value: value});
			},

			onPickerClickAway() {
				this.activeColor = null;
				this.activeValue = null;
				this.pickerPosition = null;
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../../assets/scss/_variables";

	.block-color {
		border-bottom: 1px solid $heather;
		color: $bali;
		letter-spacing: 0.06px;
		padding: 17px 0 0;

		.title {
			display: block;
			color: $black;
			margin: 0 0 15px;
		}

		p {
			margin: 0 0 14px;
		}
	}

	.list-color {
		display: flex;
		flex-direction: row;
		margin: 0 -5px 20px;

		&.style {
			li {
				width: 33.33%;
			}
		}

		&.style1 {
			li {
				width: 50%;
			}
		}

		li {
			width: 25%;
			padding: 0 5px;
		}

		.color-preview {
			display: block;
			height: 18px;
			border: 1px solid $heather1;
			margin: 0 0 7px;
		}

		.color-title {
			display: block;
			color: $black;
			margin: 0 0 4px;
		}

		.color-code {
			font-size: 11px;
			display: block;
			color: $bali1;
		}
	}

</style>
